// removed by extract-text-webpack-plugin
module.exports = {"content":"c-EmptyBagInfo__content","message":"c-EmptyBagInfo__message","bottom":"c-EmptyBagInfo__bottom","link":"c-EmptyBagInfo__link"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/EmptyBagInfo/EmptyBagInfo.scss
// module id = 483
// module chunks = 0